<button mat-button class="ribbon-button-padding">
        <mat-icon class="delete-icon" [class]="theme.myIconColor">delete_outline</mat-icon> 
        <span> Delete</span>
</button>